import Hospitals from "../../assets/images/patience/profile.jpg";

const ProfileImage = () => {
    return (
        <>
            <div className="md:w-1/3 p-4">
                <div className="flex justify-center items-center">
                    <div className="w-24 h-24 sm:w-36 sm:h-36 lg:w-48 lg:h-48 border-2 border-gray-400 rounded-full flex items-center justify-center overflow-hidden">
                        <img
                            src={Hospitals}
                            alt="Patient Photo"
                            className="w-full h-full object-cover"
                        />
                    </div>

                </div>
                <div class="justify-self-center items-center mt-4 md:mt-10 font-bold text-gray-800">
                    Profile Photo

                </div>

            </div>

        </>
    )
}

export default ProfileImage;